import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 7a3 3 0 0 1 3 3v4a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-4a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconCrop169Filled = createReactComponent('filled', 'crop-16-9-filled', 'Crop169Filled', __iconNode);

export default IconCrop169Filled;